import { useMemo } from 'react';

import { useAuth } from '../../../useAuth';

import { SyncRecordBase, useSyncModel } from '../persistence';

export interface ScanPhotoSyncRecord extends SyncRecordBase {
}

export const useScanPhotoSyncModel = () => {
  const { userId } = useAuth();
  const model = useSyncModel<ScanPhotoSyncRecord>('scanPhoto');

  return useMemo(() => ({
    ...model,
    addScanPhotoToSync: async (scanId: string, _id: string) => {
      if (!userId) throw new Error('userId required');
      try {
        await model.put({
          _id,
          userId,
          scanId,
          isSynced: false,
          isSyncing: false,
          isFailed: false,
        });
      } catch (error) {
        console.error('Failed to add scan photo to sync', error, { userId, scanId, _id });
      }
    },
  }), [model, userId]);
};
